import ufeApi from 'services/api/ufeApi';
import localeUtils from 'utils/LanguageLocale';
import Empty from 'constants/empty';

const TIMEOUT = 2000;

function getTrendingOffers(token, { contextIds, atgId = '0' }) {
    const channel = 'web';
    const locale = localeUtils.getCurrentLanguageLocale();

    const url = `/gway/v1/p13n/trending-offers?channel=${channel}&locale=${locale}&atg_id=${atgId}`;

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ context: contextIds }),
            signal: AbortSignal.timeout(TIMEOUT)
        })
        .then(({ data = Empty.Array, errorCode }) => {
            if (errorCode) {
                const error = new Error(errorCode);
                error.errorCode = errorCode;
                error.data = data;

                return Promise.reject(error);
            }

            return data;
        });
}

export default getTrendingOffers;
